module.exports = __webpack_public_path__ + "img/chinesecompany39.d8fbff74.png";